import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { isProduction } from '@/config/config'
import { fetchSandboxDot } from '@/models/insuranceApplication'

export const CT_TEST_DOT = '3300318'

interface TestDotButtonsProps {
  onPick: (dot: string) => void
  disabled?: boolean
}

/** The chat's test-number helpers, outside production only. */
export function TestDotButtons({ onPick, disabled }: TestDotButtonsProps) {
  const [loading, setLoading] = useState(false)
  if (isProduction) return null

  async function pickSandboxDot() {
    setLoading(true)
    try {
      onPick(await fetchSandboxDot())
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Button type="button" variant="outline" onClick={() => onPick(CT_TEST_DOT)} disabled={disabled}>
        CT number
      </Button>
      <Button
        type="button"
        variant="outline"
        onClick={() => void pickSandboxDot()}
        disabled={disabled}
        loading={loading ? 'Loading…' : undefined}
      >
        Test number
      </Button>
    </>
  )
}
